import { render, staticRenderFns } from "./customersList.vue?vue&type=template&id=e38825f6&scoped=true"
import script from "./customersList.vue?vue&type=script&lang=js"
export * from "./customersList.vue?vue&type=script&lang=js"
import style0 from "./customersList.vue?vue&type=style&index=0&id=e38825f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38825f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e38825f6')) {
      api.createRecord('e38825f6', component.options)
    } else {
      api.reload('e38825f6', component.options)
    }
    module.hot.accept("./customersList.vue?vue&type=template&id=e38825f6&scoped=true", function () {
      api.rerender('e38825f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/customersList.vue"
export default component.exports